import cn from 'classnames';
import { Button, Icon, TextLink, Typography } from '../../components';
import styles from './ImpersonationBanner.module.css';

export const ImpersonationBanner = ({
  name,
  exit,
  isImpersonatorUserAdmin,
  onOpenPatientNote,
}: {
  name: string;
  exit: () => void;
  isImpersonatorUserAdmin: boolean;
  onOpenPatientNote?: () => void;
}) => {
  return (
    //don't remove id='impersonate-banner' it is used for styling
    <div
      id='impersonate-banner'
      className={cn(styles.container, isImpersonatorUserAdmin && styles.admin)}
    >
      <div className={styles.infoRow}>
        <div className={styles.iconContainer}>
          <Icon name='eye' />
        </div>
        <Typography variant='heading-m'>{`Viewing: ${name}`}</Typography>
      </div>
      <div className={styles.actions}>
        {onOpenPatientNote && (
          <TextLink
            label='+ Patient Note'
            onClick={onOpenPatientNote}
            size='body-s'
            color='purple'
          />
        )}
        <Button
          onClick={() => exit()}
          color={isImpersonatorUserAdmin ? 'orange' : 'blue'}
          size='small'
        >
          Exit
        </Button>
      </div>
    </div>
  );
};
export default ImpersonationBanner;
